<template>
  <div class="btn-switcher">
    <button
      v-for="v in values"
      :key="v.title"
      class="text-left text-md-center"
      :class="[ reduce(v) == value ? 'selected' : '', buttonClass ]"
      :disabled="disabled"
      @click="handleInput(v)"

    >
      <slot name="content" v-bind="v">{{ v[label] }}</slot>
    </button>
  </div>
</template>

<script>
export default {
  name: "ButtonSwitch",
  props: {
    values: { required: true, type: Array },
    value: { },
    reduce: { type: Function, default: e => e },
    label: { type: String, default: "title"},
    buttonClass: { type: String, default: ""},
    disabled: { type: Boolean, default: false}
  },
  methods: {
    handleInput(e) {
      this.$emit("input", this.reduce(e));
    },
  },
};
</script>
